import { useSelector } from "react-redux";
import { IonCard, IonIcon, IonItem, IonLabel, IonText } from "@ionic/react";
import { selectUser } from "../../../store/userShow/selectors/selectUser";
import { cardOutline, mailOutline } from "ionicons/icons";
export const PersonalDataSection: React.FC = () => {
  const user = useSelector(selectUser);
  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">Datos personales</IonText>
      </h2>
      <IonCard>
        <IonItem lines="none">
          <IonIcon icon={cardOutline} slot="start"></IonIcon>
          <IonLabel>
            <h3>Rut</h3>
            <h3 style={{ fontWeight: 500 }}>{user?.dni}</h3>
          </IonLabel>
        </IonItem>

        <IonItem lines="none">
          <IonIcon icon={mailOutline} slot="start"></IonIcon>
          <IonLabel>
            <h3>Email</h3>
            <h3 style={{ fontWeight: 500 }}>{user?.email}</h3>
          </IonLabel>
        </IonItem>
      </IonCard>
    </>
  );
};
